module.exports = __webpack_public_path__ + "img/en.57ae46d6.png";